.value {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.notComputable {
  display: inline-flex;
  align-items: center;
  gap: var(--hcr-spacing-half);
  color: var(--hcr-warning-color);

  .warningIcon {
    width: 16px;
    height: 16px;
    color: var(--hcr-warning-color);
  }
}
